// extracted by mini-css-extract-plugin
export default {"FooterRightItem":"FooterRightItem_FooterRightItem__8bVoo","FooterRightItemLink":"FooterRightItem_FooterRightItemLink__hXvqK"};